import type { VideoModelConfig } from '../../types';

/** 可灵 3.0（默认模型） */
export const kling3_0: VideoModelConfig = {
  id: '01KK88SZ0K8N1GBR2XYWYWE291',
  isDefault: true,
  displayName: '可灵 3.0',
  defaults: {
    resolution: '720P',
    duration: 5,
    sound: 'on',
  },
  resolutionOptions: [
    { label: '720P', value: '720P' },
    { label: '1080P', value: '1080P' },
  ],
  duration: { mode: 'range', min: 3, max: 15, step: 1, default: 5 },
  capabilities: {
    sound: true,
  },
  limits: {
    maxRefImages: 1,
  },
};
